import React from "react";
import { makeStyles } from "@material-ui/styles";
import { BottomNavigation, BottomNavigationAction } from "@material-ui/core";
import LinkedIn from "@material-ui/icons/LinkedIn";
import Twitter from "@material-ui/icons/Twitter";
import Youtube from "@material-ui/icons/YouTube";

const useStyles = makeStyles({
  root: {
    // Setting Styling For Footer Icons
    "& .MuiBottomNavigationAction-root": {
      minWidth: 0,
      maxWidth: 250,
    },
    "& .MuiSvgIcon-root": {
      fill: "tan",
      "&:hover": {
        fill: "tomato",
        fontSize: "1.8rem",
      },
    },
  },
});

const Footer = () => {
  const classes = useStyles();
  return (
    /* Material UI Component BottomNavigation & BottomNavigation Action Is used */
    <BottomNavigation width="auto" style={{ background: "#222" }}>
      <BottomNavigationAction
        className={classes.root}
        style={{ padding: 0 }}
        icon={<LinkedIn />}
        href = "https://www.linkedin.com/in/ankit-rana-51488581/" target = "_blank"
      />
      <BottomNavigationAction
        className={classes.root}
        style={{ padding: 0 }}
        icon={<Twitter />}
        href = "https://twitter.com/theankitrana" target = "_blank"
      />
      <BottomNavigationAction
        className={classes.root}
        style={{ padding: 0 }}
        icon={<Youtube />}
        href = "https://youtube.com/c/developersnest" target = "_blank"
      />
    </BottomNavigation>
  );
};

export default Footer;
